import React from 'react';
import { CnLayoutCell as UICnLayoutCell } from "../../components/cn-layout";
var CnLayoutCell = function CnLayoutCell(props) {
  var _ref = props || {},
    children = _ref.children;
  return /*#__PURE__*/React.createElement(UICnLayoutCell, null, children);
};
CnLayoutCell.displayName = 'CnLayoutCell';
export default CnLayoutCell;
export { CnLayoutCell };